import { useList } from '../../../../api/react-query';

export function useRuleApplicableConfigs({ enabled = true } = {}) {
  const { data, isLoading, refetch } = useList(
    'config/ruleApplicable',
    { disablePageAndLimit: true },
    { enabled },
    'v1',
  );

  return {
    data: data?.data?.data || [],
    isLoading,
    refetch,
  };
}
